import React, { useEffect, useState } from "react";

import "../styles/ConsultantSearch.css";

import { useTranslation } from "react-i18next";

import ConsultantSearchBar from "../components/searchconsultant/ConsultantSearchBar";
import ConsultantFilters from "../components/searchconsultant/ConsultantFilters";
import ConsultantList from "../components/searchconsultant/ConsultantList";

import { getAllWilaya } from "../pages/wilaya/ServiceWilaya";
import { getSpecialiteByNatureActivityType } from  "../pages/specialite/ServiceSpecialite";
import { getActivityProfByTypeActivityPro } from "../pages/activityprof/ServiceActivityProf";
import { getAllConsultantPage } from "../pages/userapp/ServiceUserApp";

/****************************************************
 * Page principale de recherche des consultants
 ****************************************************/
export default function ConsultantSearchPage() {
    //------------------------------------------------
    // Données
    //------------------------------------------------

    const [consultants, setConsultants] = useState([]);
    const [loading, setLoading] = useState(false);
    const [wilayas, setWilayas] = useState([]);
    const [specialites, setSpecialites] = useState([]);
    const [activityProfs, setActivityProfs] = useState([]);


    const { t } = useTranslation();
    const natureActivityTypes = [
        {
            id: "C",
            libelle: t("consultant.types.agriculture")
        },
        {
            id: "L",
            libelle: t("consultant.types.livestock")
        }
    ];

    //------------------------------------------------
    // Filtres
    //------------------------------------------------

    const [filters, setFilters] = useState({
        keyword: "",
        natureActivityType: "",
        activityProfs: [],
        specialites: [],
        wilaya: "",
        experience: "",
        available: false,
        page: 0,
        size: 12

    });

    useEffect(() => {
        loadFilters();
    }, []);


    useEffect(() => {
        loadConsultantData(filters.natureActivityType);
    }, [filters.natureActivityType]);

    const searchConsultants = async () => {
        try {
            setLoading(true);
            const response = await getAllConsultantPage(
                filters.keyword,
                0.6,
                filters.natureActivityType,
                filters.specialites.map(s => s.id),
                filters.activityProfs.map(a => a.id),
                filters.wilaya,
                filters.page,
                filters.size,
                [],
                "ASC"

            );

            setConsultants(response.data.content);
            setPageInfo({
                page: response.data.number,
                totalPages: response.data.totalPages,
                totalElements: response.data.totalElements,
                size: response.data.size
            });
        }

        catch (e) {
            console.error(e);
        }

        finally {
            setLoading(false);
        }

    };
    const loadConsultantData = async (natureActivityType) => {
        if (!natureActivityType) {
            setActivityProfs([]);
            setSpecialites([]);
            return;
        }
        try {
            const [
                activityResponse,
                specialiteResponse
            ] = await Promise.all([
                getActivityProfByTypeActivityPro(
                    natureActivityType
                ),
                getSpecialiteByNatureActivityType(
                    natureActivityType
                )

            ]);

            setActivityProfs(activityResponse.data);
            setSpecialites(specialiteResponse.data);

        }

        catch (error) {

            console.error(error);

        }

    };

    //------------------------------------------------
    // Chargement
    //------------------------------------------------
    useEffect(() => {

        searchConsultants();

    }, []);


    useEffect(() => {

        searchConsultants();

    }, [
        filters.keyword,
        filters.natureActivityType,
        filters.specialites,
        filters.activityProfs,
        filters.wilaya,
        filters.experience,
        filters.available,
        filters.page,
        filters.size
    ]);


    const handleSearch = () => {

        searchConsultants();

    };
    //------------------------------------------------
    // Recherche
    //------------------------------------------------
    const handleActivityProfsChange = (selected) => {
        setFilters(prev => ({
            ...prev,
            activityProfs: selected,
            page: 0
        }));

    };

    const handleSpecialitesChange = (selected) => {
        setFilters(prev => ({
            ...prev,
            specialites: selected,
            page: 0
        }));

    };

    const handleReset = () => {

        setFilters({
            keyword: "",
            natureActivityType: "",
            activityProfs: [],
            specialites: [],
            wilaya: "",
            experience: "",
            available: false,
            page: 0,
            size: 12
        });
        setActivityProfs([]);
        setSpecialites([]);

    };
    const [pageInfo, setPageInfo] = useState({
        page: 0,
        totalPages: 0,
        totalElements: 0,
        size: 12
    });


    const loadFilters = async () => {

        try {

            const response = await getAllWilaya(
                "",
                ["wilaya"],
                "ASC"
            );

            setWilayas(response.data);

        } catch (error) {

            console.error(error);

        }

    };



    //------------------------------------------------
    // Modification filtre
    //------------------------------------------------
    const handleFilterChange = (name, value) => {

        if (name === "natureActivityType") {

            setFilters(prev => ({

                ...prev,

                natureActivityType: value,

                activityProfs: [],

                specialites: [],

                page: 0

            }));

            return;
        }

        setFilters(prev => ({

            ...prev,

            [name]: value,

            page: 0

        }));

    };

    useEffect(() => {
        //console.log("activityProfs =", filters.activityProfs);
    }, [filters.activityProfs]);

    useEffect(() => {
        //console.log("specialites =", filters.specialites);
    }, [filters.specialites]);

    //------------------------------------------------
    // Recherche bouton
    //------------------------------------------------



    //------------------------------------------------
    // Affichage
    //------------------------------------------------

    return (

        <div className="consultant-page container-fluid">

            {/* ================= HEADER ================= */}

         <ConsultantSearchBar
    filters={filters}
    onChange={handleFilterChange}
    onSearch={handleSearch}
    total={pageInfo.totalElements}
/>

            {/* ================= CONTENU ================= */}

            <div className="row mt-4">

                {/* Colonne gauche */}

                <div className="col-lg-3">


                    <ConsultantFilters
                        filters={filters}
                        natureActivityTypes={natureActivityTypes}
                        activityProfs={activityProfs}
                        specialites={specialites}
                        wilayas={wilayas}
                        onChange={handleFilterChange}
                        onSearch={handleSearch}
                        onReset={handleReset}
                        onActivityProfsChange={handleActivityProfsChange}
                        onSpecialitesChange={handleSpecialitesChange}

                    />

                </div>

                {/* Résultat */}

                <div className="col-lg-9">

                    <ConsultantList
                        loading={loading}
                        consultants={consultants}
                    />

                </div>

            </div>

        </div>

    );

}